import React from 'react'

import classNames from 'classnames'

import { useIsOptimizelyFeatureEnabled } from 'containers/OptimizelyRollouts'
import { homeConfig } from 'routes/Home/homeConfig'
import { useAuth } from 'routes/Menu/domains/auth'

import { Benefits, BenefitType } from '../../Benefits'
import { CTAHomepageContainer } from '../../CTA'
import { getCtaProps } from '../../homeUtils'
import { GetStartedProps } from './GetStartedModels'

import css from './GetStartedStyles.css'

export const GetStarted = ({ isHeroCTA, isSticky, maxHeight, ref }: GetStartedProps) => {
  const { isAuthenticated } = useAuth()
  const { ctaText, ctaUri } = getCtaProps(isAuthenticated)

  const isNewReducedPromoCodeEnabled = useIsOptimizelyFeatureEnabled(
    'beetroots_new_reduced_promocode_web_enabled',
  )

  const defaultCtaText = isNewReducedPromoCodeEnabled
    ? homeConfig.CTA.reducedStickyCtaText
    : homeConfig.CTA.stickyCTA
  const ctaTextDynamic = isSticky && !isHeroCTA && !isAuthenticated ? defaultCtaText : ctaText

  const className = isHeroCTA
    ? css.stickyContainer
    : classNames(css.mobileStickyInitial, css.mobileStickyRemoval, {
        [css.mobileSticky]: isSticky,
        [css.hideShadow]: maxHeight && isSticky,
      })

  return (
    <div
      className={className}
      ref={ref}
      style={maxHeight && !isHeroCTA ? { top: `${maxHeight}px` } : {}}
    >
      <CTAHomepageContainer
        ctaUri={ctaUri}
        sectionForTracking={isHeroCTA ? 'hero' : 'stickyCTA'}
        dataTesting={isHeroCTA ? 'homepageHeroCTA' : 'stickyCTA'}
      >
        {ctaTextDynamic}
      </CTAHomepageContainer>
      <Benefits pickFilter={[BenefitType.NO_LOCK_IN]} />
    </div>
  )
}
